import React, { useState } from 'react';

import Box from '@mui/material/Box';
import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';

import { KnzComponentProps } from '../../types';

/**
 * タブ切り替え（knz 独自の新規コンポーネント）。
 * children で `Tab` ブロックを参照する。各 Tab の `label` をタブ見出しに使う。
 */
export const Tabs: React.FC<KnzComponentProps> = ({ node, renderChildren }) => {
  const [value, setValue] = useState(0);
  const tabs = node.children.filter((c) => c.name === 'Tab');

  if (tabs.length === 0) return null;

  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <MuiTabs
        value={Math.min(value, tabs.length - 1)}
        onChange={(_, v) => setValue(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 40,
          '& .MuiTab-root': { minHeight: 40, textTransform: 'none' },
        }}
      >
        {tabs.map((t, i) => (
          <MuiTab key={i} label={(t.params.label as string) ?? `Tab ${i + 1}`} />
        ))}
      </MuiTabs>
      {tabs.map((t, i) => (
        <Box key={i} hidden={value !== i} sx={{ p: 2 }}>
          {value === i && renderChildren([t])}
        </Box>
      ))}
    </Box>
  );
};

export default Tabs;
